export default () => {
  const partners = document.querySelectorAll('.partners');

  partners.forEach((container) => {
    const observer = new IntersectionObserver((entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.disconnect();
      container.querySelectorAll('img').forEach((img) => {
        img.removeAttribute('loading');
      });
    }, { threshold: 0 });
    observer.observe(container);
  });
};
